import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Build a rounded-square SVG data-URI favicon showing 1–2 letters.
function letterIcon(text, bg, fg) {
  const fontSize = text.length > 1 ? 30 : 40;
  const svg =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">' +
    `<rect width="64" height="64" rx="14" fill="${bg}"/>` +
    `<text x="32" y="34" text-anchor="middle" dominant-baseline="central" ` +
    `font-family="Outfit, Arial, sans-serif" font-weight="700" font-size="${fontSize}" fill="${fg}">${text}</text>` +
    '</svg>';
  return 'data:image/svg+xml,' + encodeURIComponent(svg);
}

const DYN_ID = 'asg-dynamic-favicon';

// FaviconManager — swaps the browser-tab icon by context so the owner can
// tell tabs apart at a glance:
//   • /admin (any host)        → "AP" (Admin Panel)
//   • test.* host, non-admin   → "T"  (test environment)
//   • production public site   → the site's default favicon (untouched)
// It only ADDS a dynamic <link rel="icon"> when needed and removes it
// otherwise, leaving the static icons in index.html in place.
export default function FaviconManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (typeof document === 'undefined') return;
    const isAdmin = pathname.startsWith('/admin');
    const isTest = /^test\./i.test(window.location.hostname);

    let href = null;
    if (isAdmin) href = letterIcon('AP', 'var(--asg-text)', '#ffffff');
    else if (isTest) href = letterIcon('T', '#ea580c', '#ffffff');

    let link = document.getElementById(DYN_ID);
    if (href) {
      if (!link) {
        link = document.createElement('link');
        link.id = DYN_ID;
        link.rel = 'icon';
        link.type = 'image/svg+xml';
        document.head.appendChild(link);
      }
      if (link.href !== href) link.href = href;
    } else if (link) {
      // Production public pages: drop our override so the default favicon shows.
      link.remove();
    }
  }, [pathname]);

  return null;
}
